import { render, staticRenderFns } from "./storefieldconfig.vue?vue&type=template&id=ac27047e&"
import script from "./storefieldconfig.vue?vue&type=script&lang=js&"
export * from "./storefieldconfig.vue?vue&type=script&lang=js&"
import style0 from "./storefieldconfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports